import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaFileDownload, FaArrowRight } from 'react-icons/fa';
import styles from './Hero.module.css';

const toRotate = ["Software Engineer", "Full-Stack Developer", "Agentic AI Wizard"];

const Hero = () => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(150);

  useEffect(() => {
    const handleType = () => {
      const i = loopNum % toRotate.length;
      const fullText = toRotate[i];

      setText(isDeleting
        ? fullText.substring(0, text.length - 1)
        : fullText.substring(0, text.length + 1)
      );

      setTypingSpeed(isDeleting ? 30 : 150);

      if (!isDeleting && text === fullText) {
        setTimeout(() => setIsDeleting(true), 1000); // Pause at end
      } else if (isDeleting && text === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
      }
    };

    const timer = setTimeout(handleType, typingSpeed);
    return () => clearTimeout(timer);
  }, [text, isDeleting, loopNum, typingSpeed]);

  return (
    <section id="hero" className={styles.heroSection}>
      {/* Background Glow */}
      <div className={styles.bgGlow}></div>

      <div className={styles.container}>

        {/* Left Content */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className={styles.contentBox}
        >
          <div className={styles.badge}>
            <span className={styles.statusDot}></span> Available for Opensource Projects
          </div>

          <h1 className={styles.title}>
            Hi, I'm <span className="text-gradient">Prince Desai</span>
          </h1>

          <h2 className={styles.typingText}>
            I am a <span>{text}</span><span className={styles.cursor}>|</span>
          </h2>

          <p className={styles.description}>
            Engineering scalable solutions with <b>MERN & Agentic AI</b>.
            I build smart systems that run themselves.
          </p>

          <div className={styles.btnGroup}>
            <a href="#projects" className={styles.primaryBtn}>
              View Work <FaArrowRight />
            </a>
            <a href="/Prince_Desai_Resume.pdf" download className={styles.secondaryBtn}>
              Download CV <FaFileDownload />
            </a>
          </div>

          <div className={styles.socialLinks}>
            <a href="https://github.com/princedesai012" target="_blank" rel="noreferrer"><FaGithub /></a>
            <a href="https://www.linkedin.com/in/prince-desai-420910282" target="_blank" rel="noreferrer"><FaLinkedin /></a>
          </div>
        </motion.div>

        {/* Right Visual (Avatar + Floating Icons) */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className={styles.imageBox}
        >
          <div className={styles.blob}></div>
          <div className={`${styles.glassCard} glass`}>
            <img src="/prince-avatar.jfif" alt="Prince" className={styles.avatar} />
          </div>

          {/* Floating Tech Icons */}
          {/* <motion.div 
            animate={{ y: [-10, 10, -10] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            className={`${styles.floatIcon} ${styles.iconReact}`}
          >
            ⚛️
          </motion.div>
          <motion.div 
            animate={{ y: [10, -10, 10] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            className={`${styles.floatIcon} ${styles.iconPython}`}
          >
            🐍 */}
          {/* </motion.div>
          <motion.div 
            animate={{ x: [-5, 5, -5] }}
            transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
            className={`${styles.floatIcon} ${styles.iconCloud}`}
          >
            ☁️
          </motion.div>*/}
        </motion.div>

      </div>
    </section>
  );
};

export default Hero;